var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardsLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.001H9C10.104 11.001 11 10.104 11 9.00098V4.00098C11 2.89898 10.104 2.00098 9 2.00098H4C2.896 2.00098 2 2.89898 2 4.00098V9.00098C2 10.104 2.896 11.001 4 11.001ZM4 9.00098V4.00098H9L8.997 9.00098H4ZM4 22.001H9C10.104 22.001 11 21.104 11 20.001V15.001C11 13.899 10.104 13.001 9 13.001H4C2.896 13.001 2 13.899 2 15.001V20.001C2 21.104 2.896 22.001 4 22.001ZM4 20.001V15.001H9L8.997 20.001H4ZM20 22.001H15C13.896 22.001 13 21.104 13 20.001V15.001C13 13.899 13.896 13.001 15 13.001H20C21.104 13.001 22 13.899 22 15.001V20.001C22 21.104 21.104 22.001 20 22.001ZM15 15.001V20.001H19.997L20 15.001H15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 3.83167V2.75C20.2 1.23122 18.9912 0 17.5 0C16.0088 0 14.8 1.23122 14.8 2.75V3.83167C13.7238 4.21919 13.0032 5.2541 13 6.41667V8.25C13 9.76878 14.2088 11 15.7 11H19.3C20.7912 11 22 9.76878 22 8.25V6.41667C21.9968 5.2541 21.2762 4.21919 20.2 3.83167ZM16.6 2.75C16.6 2.24374 17.0029 1.83333 17.5 1.83333C17.9971 1.83333 18.4 2.24374 18.4 2.75V3.66667H16.6V2.75ZM20.2 8.25C20.2 8.75626 19.7971 9.16667 19.3 9.16667H15.7C15.2029 9.16667 14.8 8.75626 14.8 8.25V6.41667C14.8 5.91041 15.2029 5.5 15.7 5.5H19.3C19.7971 5.5 20.2 5.91041 20.2 6.41667V8.25Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsLocked);
export default ForwardRef;